import { render, staticRenderFns } from "./crmEditor.vue?vue&type=template&id=41b2e772&scoped=true&"
import script from "./crmEditor.vue?vue&type=script&lang=js&"
export * from "./crmEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b2e772",
  null
  
)

export default component.exports